const locks = new Set();
function lockBodyScrolling(lockingEl) {
    locks.add(lockingEl);
    document.body.classList.add('arc-scroll-lock');
}
function unlockBodyScrolling(lockingEl) {
    locks.delete(lockingEl);
    if (locks.size === 0) {
        document.body.classList.remove('arc-scroll-lock');
    }
}
export { lockBodyScrolling, unlockBodyScrolling };
